module.exports = __webpack_public_path__ + "img/magalu-carreiras-white.83a59d28.png";